import { constants } from './definitions';

const { knowledgeBaseUrlRoot, knowledgeBaseUrlType } = constants;

// Checks to see if the URL belongs to one hosted on the legacy knowledge base
export const isKnowledgeBaseUrl = (url: string): boolean =>
  url.includes('support.twilio.com');

// Checks to see if the URL is for an article attachment
export const isArticleAttachmentUrl = (url: string): boolean =>
  url.includes('article_attachments');

// if knowledge base URL (article, section, category, article attachment), remove the host and return relative path
export const getKnowledgeBaseUrlRelativePath = (url: string): string => {
  if (url.includes(knowledgeBaseUrlType.articleAttachments)) {
    const [, slug] = url.split(knowledgeBaseUrlType.articleAttachments);
    return `${knowledgeBaseUrlRoot.articleAttachments}${slug}`;
  }

  if (url.includes(knowledgeBaseUrlType.article)) {
    const [, slug] = url.split(knowledgeBaseUrlType.article);
    return `${knowledgeBaseUrlRoot.article}${slug}`;
  }

  if (url.includes(knowledgeBaseUrlType.category)) {
    const [, slug] = url.split(knowledgeBaseUrlType.category);
    return `${knowledgeBaseUrlRoot.category}${slug}`;
  }

  if (url.includes(knowledgeBaseUrlType.section)) {
    const [, slug] = url.split(knowledgeBaseUrlType.section);
    return `${knowledgeBaseUrlRoot.section}${slug}`;
  }

  // handles any reference to support.twilio.com/:locale
  return `${knowledgeBaseUrlRoot.default}`;
};
